<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const isDark = ref(false);

function applyTheme(dark: boolean) {
  isDark.value = dark;
  document.documentElement.classList.toggle('dark', dark);
}

function toggle() {
  applyTheme(!isDark.value);
  localStorage.setItem('astock-theme', isDark.value ? 'dark' : 'light');
}

let mq: MediaQueryList | null = null;
function handleSystemChange(e: MediaQueryListEvent) {
  applyTheme(e.matches);
}

onMounted(() => {
  const saved = localStorage.getItem('astock-theme');
  if (saved === 'dark') applyTheme(true);
  else if (saved === 'light') applyTheme(false);
  else {
    mq = window.matchMedia('(prefers-color-scheme: dark)');
    applyTheme(mq.matches);
    mq.addEventListener('change', handleSystemChange);
  }
});

onUnmounted(() => {
  mq?.removeEventListener('change', handleSystemChange);
});
</script>

<template>
  <header
    class="sticky top-0 z-30 border-b backdrop-blur-md transition-colors"
    style="background: rgb(var(--color-surface) / 0.8); border-color: rgb(var(--color-border));"
  >
    <div class="mx-auto flex max-w-[1400px] items-center justify-between px-4 py-4 sm:px-6">
      <div class="flex items-center gap-3">
        <div
          class="flex h-9 w-9 items-center justify-center rounded-lg text-white shadow-card"
          style="background: rgb(var(--color-primary));"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5">
            <path d="M3 17l6-6 4 4 8-8v4h2V3h-8v2h4l-6 6-4-4-8 8z" />
          </svg>
        </div>
        <div>
          <h1 class="text-lg font-semibold tracking-tight">A股板块趋势分析</h1>
          <p class="text-xs text-ink-muted">每日跟踪 · 智能识别强势板块</p>
        </div>
      </div>

      <button
        class="btn btn-ghost"
        :aria-label="isDark ? '切换到亮色' : '切换到暗色'"
        @click="toggle"
      >
        <svg v-if="isDark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-4 w-4">
          <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.591 1.591z" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-4 w-4">
          <path fill-rule="evenodd" d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </header>
</template>
